/**
 * Account-level chat (the cross-plan "Ask {assistant} about anyone you care for"
 * assistant) is only useful once a caregiver is juggling several plans, so it's
 * gated on a minimum plan count — independent of paid status. A paid user with
 * one or two plans still doesn't see it.
 *
 * Single source of truth for both gates:
 *   - the AI tab in navigation/useRoutes.ts
 *   - the "Ask {assistant}…" bar in screens/ProjectsScreen.tsx
 */
export const MIN_PLANS_FOR_ACCOUNT_CHAT = 3;
